<ph-dialog [open]="open"
           [attr.size]="size"
           [attr.heading]="data?.title"
           (ph-close)="closed.emit(null)">
    <ph-stack *ngIf="data && form">
        <div>{{data.content}}</div>

        <ph-field>
            <ph-label [attr.required]="data.selectionRequired ? '' : null">{{data.selectionLabel}}</ph-label>
            <ph-select [placeholder]="data.selectionLabel"
                       [attr.required]="data.selectionRequired ? '' : null"
                       [items]="selectionItems"
                       [value]="selectedIndex"
                       (ph-change)="onSelectionChange($event.detail)"></ph-select>
            <ph-hint *ngIf="data?.selectionWarning" has-error>{{data.selectionWarning(form.value.selection)}}</ph-hint>
        </ph-field>
    </ph-stack>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" (click)="closed.emit(null)">Cancel</ph-button>
        <ph-button *ngIf="data?.secondaryBtnContent"
                   variant="secondary"
                   mode="filled"
                   (click)="closeAndConfirm(true)">{{data.secondaryBtnContent}}</ph-button>
        <ph-button (click)="closeAndConfirm()">{{data?.btnContent}}</ph-button>
    </ph-actions>
</ph-dialog>
